<template>
  <v-layout align-center justify-center v-if="progress" style="height: calc(100vh - 64px); overflow-y: scroll;">
    <v-progress-circular :size="100" :width="8" indeterminate color="blue"></v-progress-circular>
  </v-layout>
  <v-card
    color="grey lighten-4"
    flat
    height="200px"
    tile
    v-else
  >
    <v-layout row justify-center>
      <!-- <ShowImageDialog :dialogshowimage="dialogshowimage" :DetailImage="DetailImage" @closeDialogShowImage="closeDialogShowImage"/> -->
      <Imagedialog :infor_image="infor_image" :chatdialog_image="chatdialog_image" @closeImagedialog="closeImagedialog"></Imagedialog>
    </v-layout>
    <v-flex v-if="infofriend.type === 'user'" xs12 md12 sm12 style="height: calc(100vh - 64px); background-color: white;" class="scrolling-wrapper">
      <v-card flat>
        <v-container>
          <v-layout align-center row wrap>
            <v-flex xs6 sm6 md6>
              <v-layout align-center justify-start>
                <v-btn icon @click="toPage('/chat-mobile/')">
                  <v-icon>chevron_left</v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs6 sm6 md6>
              <v-layout align-center justify-end>
                <v-menu v-if="statemember == 'active'">
                  <v-btn slot="activator" icon>
                    <v-icon style=" font-size: 20px !important; color: black !important;">more_vert</v-icon>
                  </v-btn>
                  <v-list style="width: 100%;padding:1vh;" class="CSChatThai">
                    <!-- <v-list-tile  @click="shownotes = !shownotes" >
                      <v-icon color="gray">fas fa-sticky-note</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">โน๊ต</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile  @click="chIsactive = $route.params.roomid" >
                      <v-icon color="gray">delete</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">ลบแชท</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile  @click="block(infofriend.data_room[0].tokenuser,infofriend.data_room[0].name)" >
                      <v-icon color="red">block</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">บล็อกเพื่อน</v-list-tile-title>
                    </v-list-tile> -->
                    <v-list-tile  @click="deletefriend(infofriend.data_room[0])" >
                      <v-icon color="red">fas fa-user-times</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">ลบเพื่อน</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
                <v-menu v-else>
                  <v-btn slot="activator" icon dark disabled>
                    <v-icon style="font-size: 20px !important; color: gray !important;">more_vert</v-icon>
                  </v-btn>
                  <!-- <v-list style="width: 100%;padding:1vh;" class="CSChatThai">
                    <v-list-tile  @click="chIsactive = $route.params.roomid" >
                      <v-icon color="gray">delete</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">ลบแชท</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile  @click="unblock(infofriend.data_room[0].tokenuser,infofriend.data_room[0].name)" >
                      <v-icon color="red">block</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai">ยกเลิกการบล็อก</v-list-tile-title>
                    </v-list-tile>
                  </v-list> -->
                </v-menu>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center justify-center style="background: #fff; ">
            <v-flex xs12 md12 sm12 style="justify-content: center; display: flex;">
              <v-avatar size="90px" class="user-photo">
                <img v-if="infofriend.data_room[0].profilepicture" :src="infofriend.data_room[0].profilepicture" class="alligator-turtle">
                <img v-else-if="infofriend.data_room[0].type === 'business'" :src="require('../../assets/robot1.png')" class="alligator-turtle">
                <img v-else-if="infofriend.data_room[0].type === 'bot'" :src="require('../../assets/robot1.png')" class="alligator-turtle">
                <img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle">
              </v-avatar>
            </v-flex>
            <v-flex xs12 md12 sm12 style="text-align: center; margin-top: 10px;">
              <v-layout align-center justify-center column>
                <p class="long_text" style="color:black; font-size:20px;">{{infofriend.data_room[0].name}}</p>
                <p class="long_text" style="color:#bcbcbc; font-size:16px;">{{infofriend.data_room[0].status}}</p>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container style="padding-top: 2px !important;">
            <v-tabs slot="extension" v-model="activeinfo" fixed-tabs color="transparent" icons-and-text centered>
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#tab-1" :key="1">
                ข้อมูลส่วนตัว
                <v-icon style="font-size: 25px !important;color: #4268fb !important;">account_box</v-icon>
              </v-tab>
              <v-tab href="#tab-2" :key="2">
                รูปภาพ
                <v-icon style="font-size: 25px !important;color: #4268fb !important;">collections</v-icon>
              </v-tab>
              <v-tab href="#tab-3" :key="3">
                ไฟล์
                <v-icon style="font-size: 25px !important;color: #4268fb !important;">file_copy</v-icon>
              </v-tab>
            </v-tabs>

            <v-tabs-items  v-model="activeinfo">
              <v-tab-item key="1" id="tab-1">
                <v-list dense style="background: none !important;margin-top: 4px !important;">
                  <v-list-tile >
                    <v-list-tile-avatar>
                      <v-icon style="color: #4268fb; font-size: 25px !important;" large>email</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-if="infofriend.data_room[0].email === ''" style="color: black !important;">-</v-list-tile-title>
                      <v-list-tile-title v-else style="color: black !important;">
                        <span class="EndpointUrl">
                          {{infofriend.data_room[0].email}}
                          <v-icon class="urlcopymessage" style="color:black; font-size: 13px !important; cursor: pointer;" v-clipboard:copy="infofriend.data_room[0].email">file_copy</v-icon>
                        </span>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider></v-divider >
                </v-list>
              </v-tab-item>
              <!-- tab info friend -->
              <v-tab-item key="2" id="tab-2"  style="overflow-y: hidden;">
                <v-flex xs12 sm12 md12>
                    <div style="background: #fff; box-shadow: none !important;" v-if="listimageinroom.length != 0">
                    <v-container v-bind="{ [`grid-list-sm`]: true }" fluid style="padding: 2px !important;">
                      <v-layout row wrap style="height: calc(100vh - 440px);" class="scrolling-wrapper">
                        <v-flex v-for="(memb, i) in listimageinroom" :key="i" xs3 sm3 md3>
                          <v-card flat tile style="cursor: pointer;">
                            <!-- <v-card-media :src="memb.path" height="15vh" width="100%" @click="dialogImg(i)">
                            </v-card-media> -->
                            <img :src="memb.path" @click="dialogImg(memb)" width="100%" height="200px" class="positionimg">
                          </v-card>
                        </v-flex>
                        <v-flex style="cursor: pointer;" v-if="showmoreimage">
                          <v-card flat tile class="justify-center">
                            <v-card-media height="15vh" @click="getimage(listimageinroom[listimageinroom.length - 1].timestamp)">
                              <v-btn round color="primary" dark>..แสดงเพิ่มเติม..</v-btn>
                            </v-card-media>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </div>
                  <h4 v-else style="color: black; text-align: center; margin-top: 20px;"> ไม่พบการส่งภาพในห้องสนทนานี้</h4>
                </v-flex>
              </v-tab-item>
              <!-- tab file friend -->
              <v-tab-item key="3" id="tab-3">
                <v-flex xs12 sm12 md12 v-if="$vuetify.breakpoint.xsOnly" >
                    <div style="background: #fff; max-height: 40vh;" v-if="listfileinroom.length != 0" class="scrolling-wrapper">
                    <v-list two-line dense dark v-for="(memb, index) in listfileinroom" :key="index">
                      <v-list-tile>
                        <v-list-tile-avatar :href="memb.path" target="_blank">
                          <v-icon style="color: #4268fb;" large> {{extension(memb.path)}}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title style="color: black !important; white-space: nowrap;width: 15em; overflow: hidden; text-overflow: ellipsis;" :href="memb.path" target="_blank"><span>{{memb.file_name}}</span>
                          </v-list-tile-title>
                          <v-list-tile-sub-title class="CSChatThai">
                            <v-btn depressed small  class="btnallow" @click="loadfile(memb)">
                              บันทึก
                            </v-btn>
                            <!-- <v-btn depressed small class="btncancel" @click="sendonebox(memb.tokenmessage)">
                              ส่งไป onebox
                            </v-btn> -->
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider >
                    </v-list>
                    <div style="display: flex;justify-content: center; width: 100%;"  v-if="showmorefile">
                    <v-btn round color="primary" dark  @click="getfile(listfileinroom[listfileinroom.length - 1].timestamp)">
                      ..แสดงเพิ่มเติม..
                    </v-btn>
                  </div>
                </div>
                  <h4 v-else style="color: black; text-align: center; margin-top: 20px;"> ไม่พบการส่งไฟล์ในห้องสนทนานี้</h4>
                </v-flex>
                <v-container v-if="$vuetify.breakpoint.smAndUp" >
                  <div style="background: #fff; max-height: 40vh;" v-if="listfileinroom.length != 0" class="scrolling-wrapper">
                  <v-layout row wrap>
                    <v-flex xs12 sm4 md4 xl3 lg3 v-for="(memb, index) in listfileinroom" :key="index" >
                      <v-flex v-if="listfileinroom.length != 0">
                        <v-card class="fileCard" >
                          <v-icon style="color: #4268fb; margin-top:15%;" size="60"> {{extension(memb.path)}}</v-icon>
                            <v-card-text style="color: black !important; white-space: nowrap;width: 15em; overflow: hidden; text-overflow: ellipsis;" :href="memb.path" target="_blank">
                              <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">{{memb.file_name}}</span>
                                </template>
                                <span>{{memb.file_name}}</span>
                              </v-tooltip>
                            </v-card-text>
                            <div class="saveButton">
                              <v-divider></v-divider>
                              <div>
                                <v-btn depressed small  class="btnallow" @click="loadfile(memb)">
                                บันทึก
                                </v-btn>
                              </div>
                            </div>
                        </v-card>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                  <div style="display: flex;justify-content: center; width: 100%;"  v-if="showmorefile">
                    <v-btn round color="primary" dark  @click="getfile(listfileinroom[listfileinroom.length - 1].timestamp)">
                      ..แสดงเพิ่มเติม..
                    </v-btn>
                  </div>
                  </div>
                  <h4 v-else style="color: black; text-align: center; margin-top: 20px;"> ไม่พบการส่งไฟล์ในห้องสนทนานี้</h4>
                </v-container>
                 <!-- <v-flex xs12 sm12 md12>
                    <div style="background: #fff; box-shadow: none !important;" v-if="listfileinroom.length != 0">
                    <v-container v-bind="{ [`grid-list-sm`]: true }" fluid style="padding: 2px !important;">
                      <v-layout row wrap style="height: calc(100vh - 440px);" class="scrolling-wrapper">
                        <v-flex v-for="(memb, index) in listfileinroom" :key="index" xs3 sm3 md3>
                          <v-card class="fileCard" >
                            <v-icon style="color: #4268fb; margin-top:15%;" size="60"> {{extension(memb.path)}}</v-icon>
                              <v-card-text style="color: black !important; white-space: nowrap;width: 15em; overflow: hidden; text-overflow: ellipsis;" :href="memb.path" target="_blank">
                                  {{memb.file_name}}
                              </v-card-text>
                              <div class="saveButton">
                                <v-divider></v-divider>
                                <div>
                                  <v-btn depressed small  class="btnallow" @click="loadfile(memb)">
                                  บันทึก
                                  </v-btn>
                                </div>
                              </div>
                        </v-card>
                        </v-flex>

                      </v-layout>
                    </v-container>
                  </div>
                  <h4 v-else style="color: black; text-align: center; margin-top: 20px;"> ไม่พบการส่งภาพในห้องสนทนานี้</h4>
                </v-flex> -->
                <!--  -->
              </v-tab-item>
            </v-tabs-items>
        </v-container>
      </v-card>
    </v-flex>

    <v-flex v-if="infofriend.type === 'group'" xs12 md12 sm12 style="height: calc(100vh - 64px); background-color: white;" class="scrolling-wrapper">
      <v-card flat>
        <v-container>
          <v-layout align-center row wrap>
            <v-flex xs6 sm6 md6>
              <v-layout align-center justify-start>
                <v-btn icon @click="toPage('/chat-mobile/')">
                  <v-icon>chevron_left</v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center justify-center style="background: #fff; ">
            <v-flex xs12 md12 sm12 style="justify-content: center; display: flex;">
              <v-avatar size="90px" class="user-photo">
                <img v-if="infofriend.picture" :src="infofriend.picture" class="alligator-turtle">
                <img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle">
              </v-avatar>
            </v-flex>
            <v-flex xs12 md12 sm12 style="text-align: center; margin-top: 10px;">
              <v-layout align-center justify-center column>
                <p class="text2" style="color:black; font-size:20px;">{{infofriend.group_name}}</p>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container style="padding-top: 2px !important;">
            <v-tabs slot="extension" v-model="activeinfo" fixed-tabs color="transparent" icons-and-text centered>
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#tab-1" :key="1">
                สมาชิก
                <v-icon style="font-size: 25px !important;color: #4268fb !important;">supervised_user_circle</v-icon>
              </v-tab>
              <v-tab href="#tab-2" :key="2">
                รูปภาพ
                <v-icon style="font-size: 25px !important;color: #4268fb !important;">collections</v-icon>
              </v-tab>
              <v-tab href="#tab-3" :key="3">
                ไฟล์
                <v-icon style="font-size: 25px !important;color: #4268fb !important;">file_copy</v-icon>
              </v-tab>
            </v-tabs>

            <v-tabs-items  v-model="activeinfo">
              <v-tab-item key="1" id="tab-1" class="layoutsearchweb" style="margin-top: 1vh !important;">
                <v-subheader style="color:black; font-weight: 900;" v-if="count_memberactive(infofriend.data_room).length != 0">สมาชิก ({{count_memberactive(infofriend.data_room).length}})</v-subheader>
                <v-subheader style="color:black; justify-content: center;" v-else>ไม่มีสมาชิก</v-subheader>
                  <div style="overflow-y:scroll!important;height: 35vh !important;">
                    <v-list dense class="layoutsearchweb" style="background: none !important; cursor: pointer;" v-for="(membactive, index) in count_memberactive(infofriend.data_room)" :key="index">
                      <v-list-tile style="padding: 1vh !important;" v-if="count_memberactive(infofriend.data_room).length != 0">
                        <v-list-tile-avatar @click="detailFriendDialog(membactive)">
                          <img v-if="membactive.profilepicture" :src="membactive.profilepicture" class="alligator-turtle">
                          <img v-else-if="membactive.type === 'business'" :src="require('../../assets/robot1.png')" class="alligator-turtle">
                          <img v-else-if="membactive.type === 'bot'" :src="require('../../assets/robot1.png')" class="alligator-turtle">
                          <img v-else :src="require('../../assets/robot1.png')" class="alligator-turtle">
                        </v-list-tile-avatar>
                        <v-list-tile-content @click="detailFriendDialog(membactive)">
                          <v-list-tile-title style="color: black; white-space: nowrap !important; width: 10em;word-break: break-all !important;">
                            {{membactive.name}}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider >
                  </v-list>
                </div>
              </v-tab-item>
              <!-- tab info friend -->
              <v-tab-item key="2" id="tab-2"  style="overflow-y: hidden;">
                <v-flex xs12 sm12 md12>
                    <div style="background: #fff; box-shadow: none !important;" v-if="listimageinroom.length != 0">
                    <v-container v-bind="{ [`grid-list-sm`]: true }" fluid style="padding: 2px !important;">
                      <v-layout row wrap style="height: calc(100vh - 440px);" class="scrolling-wrapper">
                        <v-flex v-for="(memb, i) in listimageinroom" :key="i" xs3 sm3 md3 lg3 xl3>
                          <v-card flat tile style="cursor: pointer;">
                            <!-- <v-card-media :src="memb.path" @click="dialogImg(i)" width="100%" height="200px" class="alligator-turtle">
                            </v-card-media> -->
                            <img :src="memb.path" @click="dialogImg(memb)" width="100%" height="200px" class="positionimg">
                          </v-card>
                        </v-flex>
                        <v-flex xs12 sm12 md12 xl12 lg12 style="cursor: pointer;" v-if="showmoreimage">
                          <v-card flat tile>
                            <!-- <v-card-media height="15vh" @click="getimage(listimageinroom[listimageinroom.length - 1].timestamp)">
                             ..แสดงเพิ่มเติม..
                            </v-card-media> -->
                            <v-btn round color="primary" dark @click="getimage(listimageinroom[listimageinroom.length - 1].timestamp)">
                              ..แสดงเพิ่มเติม..
                            </v-btn>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </div>
                  <h4 v-else style="color: black; text-align: center; margin-top: 20px;"> ไม่พบการส่งภาพในห้องสนทนานี้</h4>
                </v-flex>
              </v-tab-item>
              <!-- tab file friend -->
              <v-tab-item key="3" id="tab-3">
                <v-flex xs12 sm12 md12 v-if="$vuetify.breakpoint.xsOnly">
                    <div style="background: #fff; max-height: 40vh;" v-if="listfileinroom.length != 0" class="scrolling-wrapper">
                    <v-list two-line dense dark v-for="(memb, index) in listfileinroom" :key="index">
                      <v-list-tile>
                        <v-list-tile-avatar :href="memb.path" target="_blank">
                          <v-icon style="color: #4268fb;" large> {{extension(memb.path)}}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title style="color: black !important; white-space: nowrap;width: 15em; overflow: hidden; text-overflow: ellipsis;" :href="memb.path" target="_blank"><span>{{memb.file_name}}</span>
                          </v-list-tile-title>
                          <v-list-tile-sub-title class="CSChatThai">
                            <v-btn depressed small  class="btnallow" @click="loadfile(memb)">
                              บันทึก
                            </v-btn>
                            <!-- <v-btn depressed small class="btncancel" @click="sendonebox(memb.tokenmessage)">
                              ส่งไป onebox
                            </v-btn> -->
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider >
                    </v-list>
                    <div style="display: flex;justify-content: center; width: 100%;"  v-if="showmorefile">
                    <v-btn round color="primary" dark @click="getfile(listfileinroom[listfileinroom.length - 1].timestamp)">
                      ..แสดงเพิ่มเติม..
                    </v-btn>
                  </div>
                </div>
                  <h4 v-else style="color: black; text-align: center; margin-top: 20px;"> ไม่พบการส่งไฟล์ในห้องสนทนานี้</h4>
                </v-flex>
                <!--  -->
                <v-container v-if="$vuetify.breakpoint.smAndUp" >
                  <div style="background: #fff; max-height: 40vh;" v-if="listfileinroom.length != 0" class="scrolling-wrapper">
                  <v-layout row wrap align-center>
                    <v-flex xs12 sm4 md4 xl3 lg3 v-for="(memb, index) in listfileinroom" :key="index"  >
                      <v-flex v-if="listfileinroom.length != 0">
                        <v-card class="fileCard" >
                          <v-icon style="color: #4268fb; margin-top:15%;" size="60"> {{extension(memb.path)}}</v-icon>
                            <v-card-text style="color: black !important; white-space: nowrap;width: 15em; overflow: hidden; text-overflow: ellipsis;" :href="memb.path" target="_blank">
                              <v-tooltip right >
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">{{memb.file_name}}</span>
                                </template>
                                <span>{{memb.file_name}}</span>
                              </v-tooltip>
                            </v-card-text>
                            <div class="saveButton">
                              <v-divider></v-divider>
                              <div>
                                <v-btn depressed small  class="btnallow" @click="loadfile(memb)">
                                บันทึก
                                </v-btn>
                              </div>
                            </div>
                        </v-card>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                  <div style="display: flex;justify-content: center; width: 100%;"  v-if="showmorefile">
                    <v-btn round color="primary" dark  @click="getfile(listfileinroom[listfileinroom.length - 1].timestamp)">
                      ..แสดงเพิ่มเติม..
                    </v-btn>
                  </div>
                  </div>
                  <h4 v-else style="color: black; text-align: center; margin-top: 20px;"> ไม่พบการส่งไฟล์ในห้องสนทนานี้</h4>
                </v-container>
                <!--  -->
              </v-tab-item>
            </v-tabs-items>
        </v-container>
      </v-card>
      <InforfriendDialogMobile :inforfrienddialog="inforfrienddialog" @closeInforfriend="closeInforfriend" :tokeninforfriend="tokeninforfriend"></InforfriendDialogMobile>
    </v-flex>
  </v-card>
</template>
<script>
import { sync } from 'vuex-pathify'
import { Momenttime } from '@/services'
// import ShowImageDialog from '@/components/dialog/ShowImageDialog'
import InforfriendDialogMobile from '@/components/dialog/InforfriendDialogMobile'
import Imagedialog from '@/components/dialog/InfofriendImage'
var _ = require('lodash')
export default {
  data: () => ({
    dialogshowimage: false,
    DetailImage: {},
    infor_image: {},
    chatdialog_image: false,
    prevArrow: 'arrow_back_ios',
    nextArrow: 'arrow_forward_ios',
    index: '',
    dialog: false,
    cycle: false,
    progress: false,
    loading: false,
    showmorefile: false,
    showmoreimage: false,
    activeinfo: 'tab-1',
    infofriend: {},
    tokenuser: '',
    tokenroom: '',
    statemember: '',
    listimageinroom: [],
    listfileinroom: [],
    dateSend: '',
    timeSend: '',
    nicknameSend: '',
    filenameSend: '',
    picSend: '',
    pathSend: '',
    tokenmsgSend: '',
    typeuser: '',
    member: [],
    tokeninforfriend: '',
    inforfrienddialog: false,
    checkShowimage: []
  }),
  created () {
    this.tokenuser = this.$route.params.id
    this.tokenroom = this.$route.params.roomid
    this.getdataroom()
    // console.log(this.socketmessage)
  },
  components: {
    InforfriendDialogMobile,
    Imagedialog
    // ShowImageDialog
  },
  computed: {
    ...sync('*')
  },
  watch: {
    index () {
      this.timeSend = this.timethai(this.listimageinroom[this.index].timestamp)
      this.dateSend = this.datethai(this.listimageinroom[this.index].timestamp)
      this.nicknameSend = this.listimageinroom[this.index].file_owner
      this.filenameSend = this.listimageinroom[this.index].file_name
      this.picSend = this.listimageinroom[this.index].pic_pro
      this.typeuser = this.listimageinroom[this.index].type
      this.pathSend = this.listimageinroom[this.index].path
      if (this.listimageinroom.length === this.index + 1) {
        this.getimage(this.listimageinroom[this.listimageinroom.length - 1].timestamp)
      }
      if (this.index + 1 !== 0) {
        this.nextArrow = 'arrow_forward_ios'
      }
      if (this.index === 0) {
        this.prevArrow = ''
      } else {
        this.prevArrow = 'arrow_back_ios'
      }
    },
    socketupdate_file () {
      this.listfileinroom.unshift({
        file_name: this.socketupdate_file.file_name,
        file_owner: this.socketupdate_file.nickname,
        path: this.socketupdate_file.message,
        pic_pro: this.socketupdate_file.path_pic,
        timestamp: this.socketupdate_file.timestamp,
        tokenmessage: this.socketupdate_file.tokenmessage,
        tokenuser: this.socketupdate_file.tokenuser,
        typeuser: this.socketupdate_file.type
      })
    },
    socketupdate_img () {
      this.listimageinroom.unshift({
        file_name: this.socketupdate_img.file_name,
        file_owner: this.socketupdate_img.nickname,
        path: this.socketupdate_img.message,
        pic_pro: this.socketupdate_img.path_pic,
        timestamp: this.socketupdate_img.timestamp,
        tokenmessage: this.socketupdate_img.tokenmessage,
        tokenuser: this.socketupdate_img.tokenuser,
        typeuser: this.socketupdate_img.type
      })
    },
    '$route.params.roomid' () {
      // console.log('miew')
      this.tokenroom = this.$route.params.roomid
      this.getdataroom()
    }
  },
  methods: {
    closeImagedialog (value) {
      // console.log(value)
      this.chatdialog_image = value
    },
    // sendonebox (tokenmessage) {
    //   this.axios.post(process.env.VUE_APP_API_PUB + '/save_onebox2', {
    //     tokenmessage: tokenmessage,
    //     tokenuser: this.tokenuser
    //   }).then((response) => {
    //     if (response.data['status'] === 'success') {
    //       this.$swal(
    //         '',
    //         'ส่งไฟล์สำเร็จ!',
    //         'success'
    //       )
    //     } else {
    //     }
    //   })
    // },
    closeDialogShowImage () {
      this.dialogshowimage = false
    },
    closeInforfriend (value) {
      this.inforfrienddialog = value
    },
    detailFriendDialog (user) {
      // console.log(user)
      this.tokeninforfriend = user.tokenuser
      this.inforfrienddialog = true
    },
    count_memberpendingactive (member) {
      // console.log(member)
      var _ = require('lodash')
      return _.filter(member, function (member) { return member.statemember === 'pending' })
    },
    count_memberactive (member) {
      var _ = require('lodash')
      return _.filter(member, function (member) { return member.statemember === 'active' })
    },
    deletefriend (item) {
      // console.log(item)
      this.$swal({
        title: '',
        text: 'คุณต้องการลบ ' + item.name + ' ออกจากการเป็นเพื่อน?',
        type: 'warning',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '',
        cancelButtonColor: '',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.VUE_APP_API_MANAGE + '/removefriend', { tokenfriend: item.tokenuser, tokenuser: this.$route.params.id, tokenroom: this.tokenroom }).then((response) => {
            // console.log(response.data)
            if (response.data['status'] === 'success') {
              this.$swal(
                '',
                'ลบเพื่อนสำเร็จ.',
                'success'
              )
              var listchat = JSON.parse(localStorage.getItem('listchat'))
              // console.log(listchat)
              var index = _.findIndex(listchat, function (o) { return o.tokenuser === item.tokenuser })
              // console.log(index)
              if (index >= 0) {
                listchat[index].state = 'unfriend'
              }
              localStorage.setItem('listchat', JSON.stringify(listchat))
              this.$router.push('/listchat/' + this.$route.params.id)
            }
          })
        }
      })
    },
    block (tokenuserfriend, name) {
      this.$swal({
        title: 'ยืนยันการบล็อกเพื่อน',
        text: 'คุณต้องบล็อก ' + name + ' ใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.VUE_APP_API_MANAGE + '/blockfriend', { tokenfriend: tokenuserfriend, tokenuser: this.$route.params.id, tokenroom: this.$route.params.roomid }).then((response) => {
            // console.log(response.data)
            if (response.data.status === 'success') {
              this.$swal({ title: 'บล็อกเพื่อนสำเร็จ', type: 'success' })
              this.block_friend = { tokenuser: tokenuserfriend, timestamp: response.data.timestamp, event: 'block_friend' }
            } else {
              this.$swal({ title: 'ไม่สามารถบล็อกเพื่อนได้!', type: 'warning' })
            }
          })
        }
      })
    },
    unblock (tokenFriend) {
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/web/getlistblockfriend', { tokenuser: this.$route.params.roomid }).then((response) => {
        var room = response.data['listBlockFriend'][this.findWithAttr(response.data['listBlockFriend'], 'tokenuser', tokenFriend)]['tokenroom']
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/unblockfriend', { tokenfriend: tokenFriend, tokenuser: this.$route.params.id, tokenroom: room }).then((response) => {
          if (response.data['status'] === 'success') {
            this.$swal(
              '',
              'ยกเลิกการบล็อคสำเร็จ.',
              'success'
            )
            this.relation = 'friend'
            this.axios.post(process.env.APImanage + '/web/getlistblockfriend', { tokenuser: this.token }).then((response) => {
            })
          }
        })
      })
    },
    // closemodal () {
    //   var modal = document.getElementById('myModalR')
    //   modal.style.display = 'none'
    // },
    // zoom (url, alt, nickname, pic, timestamp, tokenmessage, type) {
    //   this.dateSend = Momenttime.momentdatethai(timestamp)
    //   this.timeSend = Momenttime.momenttimethai(timestamp)
    //   var modal = document.getElementById('myModalR')
    //   var modalImg = document.getElementById('img02')
    //   modal.style.display = 'block'
    //   modalImg.src = url
    //   this.nicknameSend = nickname
    //   this.filenameSend = alt
    //   this.picSend = pic
    //   this.pathSend = url
    //   this.tokenmsgSend = tokenmessage
    //   this.typeuser = type
    // },
    dialogImg (item) {
      this.chatdialog_image = true
      this.infor_image = {
        'nickname': item.file_owner,
        'timestamp': item.timestamp,
        'file_name': item.file_name,
        'message': item.path,
        'profilepicture': item.pic_pro,
        'tokenmessage': item.tokenmessage,
        'tokenuser': item.tokenuser
      }
      // this.dialogshowimage = true
      // this.DetailImage = {
      //   'nickname': item.file_owner,
      //   'timestamp': item.timestamp,
      //   'file_name': item.file_name,
      //   'message': item.path,
      //   'profilepicture': item.pic_pro,
      //   'tokenmessage': item.tokenmessage,
      //   'tokenuser': item.tokenuser,
      //   'path_pic': item.pic_pro
      // }
    },
    datethai (timestamp) {
      return Momenttime.momentdatethai(timestamp)
    },
    timethai (timestamp) {
      return Momenttime.momenttimethai(timestamp)
    },
    loadfile (memb) {
      // console.log(memb)
      this.axios.get(memb.path, { responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', memb.file_name)
        document.body.appendChild(link)
        link.click()
      })
    },
    // loadpic (filenameSend) {
    //   // console.log(memb)
    //   this.loading = true
    //   this.axios.get(this.DetailImage.path, { responseType: 'blob' }).then((response) => {
    //     const url = window.URL.createObjectURL(new Blob([response.data]))
    //     const link = document.createElement('a')
    //     link.href = url
    //     link.setAttribute('download', filenameSend)
    //     document.body.appendChild(link)
    //     link.click()
    //     this.loading = false
    //   })
    // },
    toPage (data) {
      this.$router.push(data + this.tokenuser + '/' + this.tokenroom)
    },
    getdataroom () {
      this.progress = true
      this.infofriend = {}
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/getroom', { tokenuser: this.tokenuser, tokenroom: this.tokenroom }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.infofriend = response.data
          this.statemember = response.data.statemember
          // console.log(this.detail.group_id)
          this.getimage('')
          this.getfile('')
          if (response.data.data_room[0].statemember === 'active') {
            // this.getnote()
          }
          this.progress = false
        }
      })
    },
    getimage (time) {
      this.axios.post(process.env.VUE_APP_API_PUB + '/file/twe_img', { tokenuser: this.tokenuser, tokenroom: this.tokenroom, time_in: time, type: 'bot' }).then((response) => {
        var getimage = []
        if (response.data['data'].length === 20) {
          this.showmoreimage = true
        } else {
          this.showmoreimage = false
        }
        this.checkShowimage = response.data['data'].length
        if (this.checkShowimage === 0) {
          this.nextArrow = ''
        }
        if (time === '') {
          getimage = response.data['data']
          this.listimageinroom = _.orderBy(getimage, 'timestamp').reverse()
          // this.listimageinroom =  _.orderBy(this.listimageinroom, 'timestamp')
        } else {
          getimage = _.orderBy(response.data['data'], 'timestamp').reverse()
          this.listimageinroom.push.apply(this.listimageinroom, getimage)
        }
      })
    },
    getfile (time) {
      this.axios.post(process.env.VUE_APP_API_PUB + '/file/twe_file', { tokenuser: this.tokenuser, tokenroom: this.tokenroom, time_in: time, type: 'bot' }).then((response) => {
        // console.log(response.data)
        if (response.data['data'].length === 20) {
          this.showmorefile = true
        } else {
          this.showmorefile = false
        }
        if (time === '') {
          this.listfileinroom = response.data['data']
        } else {
          this.listfileinroom.push.apply(this.listfileinroom, response.data['data'])
        }
      })
    },
    extension (path) {
      var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else {
        return 'fas fa-file-alt'
      }
    }
  }
}
</script>
<style type="text/css" scoped>
>>>.v-carousel__next .v-btn i {
  font-size: 38px !important;
}
>>>.v-carousel__prev .v-btn i {
  margin-left: 50%;
  margin-right: 20%;
  font-size: 38px !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  overflow-y: hidden;
  top: 0;
  left: 0;
}
>>>.v-image__image--cover {
  background-size: contain !important;
}
>>>.v-image__image .v-image__image--cover {
  background-position: center center !important;
  background-size: contain !important;
}
.long_text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 145px;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.positionimg {
  object-fit: cover;
  object-position: 50% 25%;
}
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 4px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
>>>.theme--dark.v-list {
  background: #ffffff;
  color: #fff;
}
.btncancel {
  border-style: solid !important;
  color: white !important;
  background-color: #4268fb !important;
  border-radius: 8px !important;
  border-color: #4268fb !important;
  border-width: thin !important;
}
.btnallow {
  border-style: solid !important;
  color: white !important;
  background-color: #4268fb !important;
  border-radius: 8px !important;
  border-color: #4268fb !important;
  border-width: thin !important;
}
.modalc {
  overflow-x: hidden !important;
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  /*padding-top: 20vh;  Location of the box */
  left: 0;
  top: 0;
  width: 100vw; /* Full width */
  height: 100vh; /* Full height */
  overflow: auto; /* Enable scroll if needed */
 /* background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
  /*background-color: white;*/
}

/* Modal Content (Image) */
.modal-contentc {
    padding-top: 10vh;
    margin: auto;
    display: block;
    width: 80%;
    width: auto;
    height: 70vh;
}

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 100vw;
    text-align: center;
    color: #ccc;
    padding: 10px 0;
    height: 150px;
}

#headcaption {
    /*margin: auto;*/
    display: block;
    margin-top: 45px;

    /*width: 80%;*/
    /*max-width: 100vw;*/
    text-align: left;
    color: white;
    /*padding-left: 15vw ;*/
    padding-top: 1vh;
    padding-bottom: 1vh;
    /*background-color: white;*/
    background-color: #1b232d;
    /*height: 150px;*/
}
/* Add Animation - Zoom in the Modal */
.modal-content, #caption {
    animation-name: zoom;
    animation-duration: 0.6s;
}

@keyframes zoom {
    from {transform:scale(0) }
    to {transform:scale(1) }
}

/* The Close Button */
.closeR {
    margin-top: 45px;
    position: absolute;
    top: 15px;
    right: 35px;
    color: white;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
}

.closeR:hover,
.closeR:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
    .modal-content {
        width: 100vw;
    }
}
/*.picgroup:hover {
  background: black !important;
}
*/
.buttonsubmit {
  background-color: #ffffffde !important;
  color: green !important;
  width: 105px !important;
  border-radius: 50px !important;
  padding: .75em;
  border: 1px green solid;
  background: linear-gradient(to right, #077629, #077629);
  background-repeat: no-repeat;
  background-size: 0 100%;
  transition: background-size 0.2s 0s;
}
.buttonsubmit:hover {
  background-size: 100% 100%;
  color: white !important;
  border: none !important;
}
/* .BoxFile{
  width: 100px;
  height: 100px;
  background-color: red;
} */
/* .v-card.fileCard{
  border-color: red solid 2px;
} */
/* >>>.v-card{
  border-color: red 2px solid !important;
} */
>>>.theme--light .v-card.fileCard {
  /* border-left: 2px solid red !important;
  border-right: 2px solid red !important;
  border-top: 2px solid red !important;
  border-bottom: 2px solid red !important; */
  border: 2px solid rgba(0,0,0,0.12) !important;
  border-radius: 10px;
}
>>>.theme--light .v-card.fileCard:hover .saveButton {
  display: inline-block;
}
.saveButton{
  display: none;
}
.fileCard {
  margin-bottom: 20%;
  width:200px;
  height:200px;
  margin-bottom:30px;
  display:inline-block;
}
</style>
